import { useNavigate } from 'react-router-dom';
import { VendorLayout as BaseVendorLayout } from '@festpix/ui';
import { auth } from '@festpix/services';

interface VendorLayoutProps {
  children: React.ReactNode;
  boothName?: string;
}

export default function VendorLayout({ children, boothName }: VendorLayoutProps) {
  const navigate = useNavigate();

  const handleSignOut = () => {
    auth.signOut();
    navigate('/login');
  };

  return (
    <BaseVendorLayout boothName={boothName} onSignOut={handleSignOut}>
      {children}
    </BaseVendorLayout>
  );
}
